<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed } from 'vue';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import formAlerts from '@/components/form-alerts/form-alerts.vue';

const { register } = useUserStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();

const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

let formAlert = ref();
const activeValidation = ref(false);
const validate = computed(() => {
    return yup.object({
        username: yup.string().required(),
        email: yup.string().required().email(),
        password: yup.string().required()
    });
});

const emailFormat = computed( () => {
    email.value = email.value.toLowerCase().replace(/ /g,'');
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [username, email, password, passwordconfirm] = useFieldModel(['username', 'email', 'password']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        emit('onSubmit', true);
        const error = await register(values);
        emit('onSubmit', false);
        activeValidation.value = false;
        if (error) {
            resetForm();
            await formAlert.value.addMsg({type: 'error', content: 'modals.alerts.errorSubmitRegisterForm'});
        } else {
            resetForm();            
            await formAlert.value.addMsg({type: 'success', content: 'modals.alerts.successSubmitRegisterForm'});
            closeModal('register');
        }
    } catch (ex) {
        isSubmitting.value = false;
        await formAlert.value.addMsg({type: 'error', content: 'modals.alerts.errorSubmitRegisterForm'});
    }
});

function doLogin() {
    toggleModal('login');
}
</script>

<template src="./modal-register.html"></template>
